import { render } from "./warehouse-items.vue?vue&type=template&id=54ee53b8&scoped=true"
import script from "./warehouse-items.vue?vue&type=script&lang=js"
export * from "./warehouse-items.vue?vue&type=script&lang=js"

import "./warehouse-items.vue?vue&type=style&index=0&id=54ee53b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ee53b8"]])

export default __exports__